import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  TimePicker: {
    width: '100%',
    display: 'flex',
  },
  Title: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingRight: '8px',
  },
  Picker: {
    maxWidth: '65%',
    flexBasis: '65%',
  },
}));

export { useStyles };
